import Chip, { type ChipProps } from '@mui/material/Chip'
import { styled, alpha } from '@mui/material/styles'

import React from 'react'

type SidebarFilterChipProps = {
  selected?: boolean
} & Omit<ChipProps, 'variant' | 'color'>

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<SidebarFilterChipProps>(({ theme, selected }) => ({
  width: '100%',
  borderRadius: theme.shape.borderRadiusChip,
  backgroundColor: selected ? theme.palette.primary.main : 'transparent',
  color: selected ? theme.palette.primary.contrastText : theme.palette.text.primary,
  border: 'none',
  '& .MuiChip-label': {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  '&:hover': {
    backgroundColor: selected ? theme.palette.primary.dark : '#E5E5E5',
  },
}))

const SidebarFilterChip: React.FC<SidebarFilterChipProps> = ({ selected = false, ...props }) => {
  return <StyledChip clickable selected={selected} {...props} />
}

export default SidebarFilterChip
